/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogEventSchema
 */
export interface LogEventSchema {
    /**
     * 
     * @type {number}
     * @memberof LogEventSchema
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof LogEventSchema
     */
    message: string;
}

/**
 * Check if a given object implements the LogEventSchema interface.
 */
export function instanceOfLogEventSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function LogEventSchemaFromJSON(json: any): LogEventSchema {
    return LogEventSchemaFromJSONTyped(json, false);
}

export function LogEventSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogEventSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'message': json['message'],
    };
}

export function LogEventSchemaToJSON(value?: LogEventSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'message': value.message,
    };
}

